import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface IHttpService {
  http: AxiosInstance;
  httpBlob: AxiosInstance;
}

export class HttpService implements IHttpService {
  get http(): AxiosInstance {
    const instance = axios.create({
      headers: this.getHeaders()
    });

    return instance;
  }

  get httpBlob(): AxiosInstance {
    const instance = axios.create();

    return instance;
  }

  get json(): AxiosInstance {
    const instance = axios.create();
    return instance;
  }

  getHeaders(username = null, token = null) {
    return { Authorization: `Bearer ${token || sessionStorage.getItem('token')}`,
    }
  }
}

export const httpService = new HttpService();

export const http = httpService.http;
